import { defineStore } from 'pinia';
import { api } from '../client/setup.js';
import { useGlobalStore } from '../global/index.js';

const getDefaultState = () => ({
  session: null,
});

export const useSessionStore = defineStore('session', {
  state: () => ({ ...getDefaultState() }),
  actions: {
    reset() {
      this.$reset();
    },
    async refreshAndInitializeSession() {
      const globalStore = useGlobalStore();
      const apiId = 'refreshAndInitializeSession';
      if (globalStore.isApiIdCallInProgress(apiId)) return;
      globalStore.incrementApiCallsInProgress(apiId);

      try {
        const initialRequestData = {
          locale: window.AppData.locale,
          servicePathAndSearch: `${window.location.pathname}${window.location.search}`,
        };
        const { data: initialSessionStatus } = await api.post('session', initialRequestData);
        let resp = { ...initialSessionStatus };

        if (initialSessionStatus?.ssoClientLoginUrl) {
          const { data: ssoData } = await api.get(initialSessionStatus.ssoClientLoginUrl, {
            withCredentials: true,
            headers: {
              'X-garmin-client-id': undefined,
            },
          }).catch((e) => {
            if (typeof e === 'object') e.response = { data: resp };
            throw e;
          });
          const { data: loginData } = await api.post('session', ssoData);
          resp = { ...loginData };
        }

        this.session = resp;
      } catch (e) {
        this.session = e?.response?.data || { valid: false };
      } finally {
        globalStore.decrementApiCallsInProgress(apiId);
      }
    },
  },
});

export default useSessionStore;
